import { RegularKeys } from '../../lib/keys';
const KEY_BIT_POSITIONS = {
    'ArrowLeft': 0,
    'ArrowRight': 1,
    'ArrowUp': 2,
    'ArrowDown': 3,
    'Space': 4,
};
export class KeyReplayer extends RegularKeys {
    constructor(keyHistory) {
        super();
        this.keyHistory = [];
        this.historyIndex = 0;
        this.frameCount = 0;
        this.started = false;
        this.currentBitfield = 0;
        this.lastBitfield = 0;
        this.keyHistory = keyHistory;
    }
    start() {
        this.started = true;
    }
    isPressed(keyCode) {
        if (KEY_BIT_POSITIONS[keyCode] === undefined) {
            return false;
        }
        const bitPosition = KEY_BIT_POSITIONS[keyCode];
        return (this.currentBitfield & (1 << bitPosition)) !== 0;
    }
    wasPressedThisFrame(keyCode) {
        if (KEY_BIT_POSITIONS[keyCode] === undefined) {
            return false;
        }
        const bitPosition = KEY_BIT_POSITIONS[keyCode];
        return (this.currentBitfield & (1 << bitPosition)) !== 0 &&
            (this.lastBitfield & (1 << bitPosition)) === 0;
    }
    wasReleasedThisFrame(keyCode) {
        const bitPosition = KEY_BIT_POSITIONS[keyCode];
        return (this.currentBitfield & (1 << bitPosition)) === 0 &&
            (this.lastBitfield & (1 << bitPosition)) !== 0;
    }
    resetFrame() {
        if (!this.started) {
            return;
        }
        if (this.historyIndex >= this.keyHistory.length) {
            return;
        }
        const [frame, bitfield] = this.keyHistory[this.historyIndex];
        if (frame === this.frameCount) {
            this.lastBitfield = this.currentBitfield;
            this.currentBitfield = bitfield;
            this.historyIndex++;
        }
        this.frameCount++;
    }
}
